import { render, staticRenderFns } from "./ProjectsCards.vue?vue&type=template&id=753a5512&scoped=true&"
import script from "./ProjectsCards.vue?vue&type=script&lang=js&"
export * from "./ProjectsCards.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsCards.vue?vue&type=style&index=0&id=753a5512&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753a5512",
  null
  
)

export default component.exports